import React from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { ReactComponent as TrashIcon } from '../../../../assets/icons/trash.svg'
import ButtonIcon from '../../../../features/components/Buttons/ButtonIcon'
import Loader from '../../../../components/Loaders/Loader'

import { deleteSelfAccountRepresentativeIsLoadingSelector } from '../../../../modules/selectors/selfAccounts'

import useStyles from './styles'

const DeleteRepresentativeButton = ({ className, id, ...props }) => {
  const classes = useStyles()

  const isDeleting = useSelector(deleteSelfAccountRepresentativeIsLoadingSelector(id))

  if (isDeleting) {
    return <Loader className={classnames(className, classes.loader)} show={true} />
  } else {
    return <ButtonIcon className={className} {...props} Icon={TrashIcon} />
  }
}

export default DeleteRepresentativeButton
